import { useCallback, useRef } from 'react';
export const useCachedOperation = operation => {
  const cache = useRef({});
  return useCallback((cacheKey, ...args) => {
    const cachedValue = cache.current[cacheKey];
    if (typeof cachedValue !== 'undefined') {
      return cachedValue;
    } else {
      const newValue = operation(cacheKey, ...args);
      cache.current[cacheKey] = newValue;
      return newValue;
    }
  }, [operation]);
};